import styled from 'styled-components';
import { Body } from 'components/Typography';
import Placeholder from 'components/Placeholders/BasicPlaceholder';
import addAlpha from 'utils/addAlpha';
import NoOrderIcon from 'assets/icons/no-order.svg?react';

export const Container = styled(Placeholder)``;

export const Icon = styled(NoOrderIcon)`
  width: 5rem;
  height: 5rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
`;

export const Title = styled(Body)`
  font-weight: 600;
  margin-bottom: 1.5625rem;
`;

export const Subtitle = styled(Body)`
  margin-bottom: 1.625rem;
`;
